import { Component, Input, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import {
  ModalDismissReasons,
  NgbDate,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {
  SUBSCRIPTIONSTATUS
} from 'src/app/core/constants/data.constant';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'order-subscription',
  templateUrl: './order-subscription.component.html',
  styleUrls: ['./order-subscription.component.scss'],
  providers: [DatePipe]
})
export class OrderSubscriptionComponent implements OnInit {
  @Input() embedded = false;
  bearer;
  store_id;
  carts = [];
  expanded = [];
  allCarts = [];
  listData = [];
  page = 1;
  selectedPage = 20;
  start = 0;
  end = 0;
  dataIsLoading = true;
  search = '';
  storeId;
  id;
  filteredOrderType: string = '';

  orderId;
  pageSize = 20;
  statusFilters = [];
  orderPaginationList;

  closeResult = '';
  selectedcarts: any;

  minDate;
  maxDate;
  startDate;
  endDate;
  currentDate;
  day;
  month;
  year;
  myDate = new Date();
  date = {
    type: null,
    yesterday: [],
    today: [],
    cm: [],
    lm: [],
    cy: [],
    raw: [],
  };
  formattedDate = '';
  

  // loading = true;

  DATE_FILTERS = [
    { display: 'Today', value: 'today', range: false, selectable: false },
    { display: 'Yesterday', value: 'yesterday', range: false, selectable: false },
    { display: 'Current Month', value: 'cm', range: false, selectable: false },
    { display: 'Last Month', value: 'lm', range: false, selectable: false },
    { display: 'Last 30 Days', value: 'last30', range: false, selectable: false },
  ];

  filteredString: string = '';

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  dateFilter: any;
  orderTypeFilters = [];
  cartStatusFilters = [];
  platformTypeFilters = [];
  selectedOrderType;
  selectedPlatformType;
  selectedStatus;
  storeCartsData = [];
  searchCarts;
  searchCartsData;
  finalList = [];
  subscripiton;
  subscriptionStatusFilters = [];
  subscriptionDateTypeFilters = [ {display: 'View All', value: ''},{display: 'Created Date', value: 'createdDate'},{display: 'Next Recurring Date', value: 'nextRecurringDate'},];
  selectedSubscripitonStatus; // = { display:'All', value:'ALL' };
  selectedSubscriptionDateType = { display:'View All', value:'' };;
  dateType;

  filterTable = [
    {
      filterName: 'selectedSubscripitonStatus',
      filterCallback: (orderData, filterValue) => 
        orderData?.statusWord === filterValue,    
    }
  ];

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    public utils: UtilitiesService,
    private datePipe: DatePipe,
    private router: Router,
  ) {
    this.dateFilter = this.DATE_FILTERS[2];
  }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    this.day = this.myDate.getDate();
    this.month = this.myDate.getMonth(); // Be careful! January is 0, not 1
    this.year = this.myDate.getFullYear();
    this.currentDate = this.year + '-' + (this.month + 1) + '-' + this.day;
    this.startDate = this.year + '-' + (this.month + 1) + '-01';
    this.endDate = this.currentDate;
    this.minDate = { year: 2021, month: 1, day: 1 };
    this.maxDate = { year: this.year, month: this.month + 1, day: this.day };

    this.datePeriod();
  }

  getSubscription(){
    this.orderId = '';
    this.dataIsLoading = true;
    this.svc
      .getSubscription(
        this.bearer,
        this.store_id,
        this.startDate,
        this.endDate,
        this.page,
        1000,
        this.dateType
      )
      .subscribe(
        (res) => {
          this.subscripiton = res['data']['data'];

          if (this.subscripiton && this.subscripiton.length > 0) {
            this.subscripiton.forEach((value, index) => {
              this.expanded[index] = false;
            });
          }

          this.getFilterGroup();
          this.dataIsLoading = false;
        },
        (error) => {
          this.dataIsLoading = false;
        }
      );
  }

  getFilterGroup() {
    const subscripitonFilters = [
      'ALL',
      ...[...new Set(this.subscripiton.map((item) => item.statusWord))].sort(),
    ];
    this.subscriptionStatusFilters = subscripitonFilters.map((item) => ({
      display: this.getSubscriptionStatus(item)?.display,
      value: item,
    }));
  }

  getSubscriptionDate(dateType){
    this.selectedSubscriptionDateType.display = dateType.display;
    this.dateType = dateType.value;
    this.dataIsLoading = true;
    this.svc
    .getSubscription(
      this.bearer,
      this.store_id,
      this.startDate,
      this.endDate,
      this.page,
      1000,
      this.dateType
    )
    .subscribe(
      (res) => {
        this.subscripiton = res['data']['data'];

        if (this.subscripiton && this.subscripiton.length > 0) {
          this.subscripiton.forEach((value, index) => {
            this.expanded[index] = false;
          });
        }

        this.getFilterGroup();
        this.dataIsLoading = false;
      },
      (error) => {
        this.dataIsLoading = false;
      }
    );
    console.log(dateType);
  }

  getDetailLink(id: number){
    return `/dashboard/order-subscription/detail/${id}/${this.store_id}`;
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.sliceRecord(this.subscripiton);
  }

  searchID(event) {
    if (event.target.value === '') {
      this.page = 1;
      this.getSubscription();
    } else {
      this.page = 1;
      this.search = event.target.value;
      console.log('check123123123',event.target.value);
      this.getSubscriptionSearch();
    }
  }

  getSubscriptionSearch(){
    this.dataIsLoading = true;
    this.svc
    .getSubscriptionSearch(
      this.bearer,
      this.store_id,
      this.startDate,
      this.endDate,
      this.page,
      1000,
      this.search
    )
    .subscribe(
      (res) => {
        this.subscripiton = res['data']['data'];

        if (this.subscripiton && this.subscripiton.length > 0) {
          this.subscripiton.forEach((value, index) => {
            this.expanded[index] = false;
          });
        }

        this.getFilterGroup();
        this.dataIsLoading = false;
      },
      (error) => {
        this.dataIsLoading = false;
      }
    );
  }

  private static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  clearDateRange() {
    this.fromDate = null;
    this.toDate = null;
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  setDueDate() {
    this.dateFilter = null;
    const start = moment(
      `${this.fromDate.day}/${this.fromDate.month}/${this.fromDate.year}`,
      'DD/MM/YYYY'
    );
    const end = moment(
      `${this.toDate.day}/${this.toDate.month}/${this.toDate.year}`,
      'DD/MM/YYYY'
    );

    if (start && end) {
      const rangeVal = `${start.format('DD-MMM-YYYY')} to ${end.format(
        'DD-MMM-YYYY'
      )}`;
      this.date.type = {
        value: { start: start, end: end },
        display: rangeVal,
        range: true,
      };
      this.startDate = `${start.format('YYYY-MM-DD')}`;
      this.endDate = `${end.format('YYYY-MM-DD')}`;
    }
    this.page = 1;
    this.getSubscription();
  }

  dateUpdated(filter) {
    this.dateFilter = filter;
    this.datePeriod();
  }

  datePeriod() {
    this.DATE_FILTERS.forEach((item) => {
      item.selectable = false;
    });

    if (this.dateFilter) {
      this.dateFilter.selectable = true;
    }

    let start = moment();
    let end = moment();

    if (this.dateFilter?.value === 'today') {
      start = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    } else if (this.dateFilter?.value === 'yesterday') {
      const yesterday = moment().subtract(1, 'days');
      start = yesterday.clone();
      end = yesterday.clone();
    } else if (this.dateFilter?.value === 'cm') {
      start = moment(`01/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    } else if (this.dateFilter?.value === 'lm') {
      const lastMonth = moment().subtract(1, 'month');
      start = lastMonth.clone().startOf('month');
      end = lastMonth.clone().endOf('month');
    } else if (this.dateFilter?.value === 'last30') {
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      start = end.clone().subtract(30, 'days');
    } else {
      // Default to Current Month
      start = moment(`01/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
      end = moment(`${this.day}/${this.month + 1}/${this.year}`, 'DD/MM/YYYY');
    }

    if (start && end) {
      const rangeVal = `${start.format('DD-MMM-YYYY')} to ${end.format(
        'DD-MMM-YYYY'
      )}`;
      this.date.type = {
        value: { start: start, end: end },
        display: this.dateFilter?.display || rangeVal,
        range: true,
      };
      this.startDate = `${start.format('YYYY-MM-DD')}`;
      this.endDate = `${end.format('YYYY-MM-DD')}`;
    }
    this.page = 1;

    this.getSubscription();
  }

  clearSubscriptionSearch() {
    this.search = '';
    this.page = 1;
    this.getSubscription();
  }

  get filteredSubsciptionHistoryList() {
    const selectedFilters = {};
    const filterTable = this.filterTable;

    Object.values(filterTable).forEach(({ filterName, filterCallback }) => {
      const value = this[filterName]?.value;
      if (value !== undefined && value !== 'ALL' && value !== '') {
        selectedFilters[filterName] = value;
      }
    });

    let filteredCartList = this.subscripiton;

    if (Object.keys(selectedFilters).length === 0) {
      this.finalList = this.subscripiton;
      return this.sliceRecord(this.subscripiton);
    } else {
      Object.keys(selectedFilters).forEach((filterKey) => {
        const filterValue = selectedFilters[filterKey];
        const filterData = this.getFilterDataByName(filterKey);

        filteredCartList = filteredCartList.filter((item) =>
          filterData?.filterCallback(item, filterValue)
        );
      });
      this.finalList = filteredCartList;
      return this.sliceRecord(this.finalList);
    }
  }

  sliceRecord(data) {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end = this.end > data.length ? data.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    return data.slice(this.start, this.end);
  }

  getFilterDataByName(filterName) {
    return this.filterTable.find((filter) => filter?.filterName === filterName);
  }

  getSubscriptionStatus(key) {
    return SUBSCRIPTIONSTATUS[key?.toUpperCase()];
  }

  public getWindowType(): string {
    if (window.innerWidth >= 560 && window.innerWidth < 761) {
      return 'tablet';
    } else if (window.innerWidth >= 340 && window.innerWidth < 560) {
      return 'mobile';
    } else {
      return 'screen';
    }
  }

  openFilter(content) {
    this.modalService
      .open(content, {
        windowClass: 'modal-filter-container',
        ariaLabelledBy: 'modal-basic-title',
        backdropClass: 'modal-filter-backdrop',
        centered: true,
        animation: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  convertDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'MMMM d, y');
  }

  convertRecurringDateDate(dateString: string): string {
    if(dateString === "0000-00-00" || dateString === "" || dateString === undefined){
      return "-"
    }else{
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'MMM d, y');
    }
  }

  getStatus(key) {
    return SUBSCRIPTIONSTATUS[key?.toUpperCase()];
  }

  // Status tabs above the list: each status in the loaded subscriptions, in
  // lifecycle order, with how many subscriptions it holds.
  private statusTabCache: { source: any[]; key: string; tabs: any[] } = {
    source: null,
    key: '',
    tabs: [],
  };

  get statusTabs(): { option: any; count: number }[] {
    const source = this.subscripiton || [];
    const key = `${source.length}#${this.subscriptionStatusFilters.map((option) => option.value).join('|')}`;
    if (source === this.statusTabCache.source && key === this.statusTabCache.key) {
      return this.statusTabCache.tabs;
    }
    const lifecycle = [
      'ACTIVE',
      'PENDING',
      'PENDING PAYMENT',
      'FLOATING',
      'COMPLETED',
      'ENDED',
      'TERMINATED',
      'CANCELLED',
      'VOID',
    ];
    const rank = (value) => {
      const index = lifecycle.indexOf(String(value).toUpperCase());
      return index === -1 ? lifecycle.length : index;
    };
    const statuses = this.subscriptionStatusFilters
      .filter((option) => option.value !== 'ALL')
      .sort((a, b) => rank(a.value) - rank(b.value));
    const tabs = [
      { option: { display: 'View All', value: 'ALL' }, count: source.length },
      ...statuses.map((option) => ({
        option,
        count: source.filter((item) => item?.statusWord === option.value).length,
      })),
    ];
    this.statusTabCache = { source, key, tabs };
    return tabs;
  }

  isSelectedFilter(selected: any, option: any): boolean {
    return (selected?.value || 'ALL') === option?.value;
  }

  selectStatusTab(option: any) {
    this.selectedSubscripitonStatus = option;
    this.page = 1;
  }

  // "More filters" holds the date type (which date the range applies to).
  isDateTypeSelected(option: any): boolean {
    return (this.dateType || '') === option?.value;
  }

  get moreFilterCount(): number {
    return this.dateType ? 1 : 0;
  }

  clearMoreFilters() {
    this.getSubscriptionDate(this.subscriptionDateTypeFilters[0]);
  }

  // Phones fold the toolbar filters behind a "Filters" button next to the
  // search; its count says how many of them are narrowing the list.
  toolbarOpen = false;

  get toolbarFilterCount(): number {
    const dateChanged = this.dateFilter?.value !== 'cm' || (this.fromDate && this.toDate);
    return (dateChanged ? 1 : 0) + this.moreFilterCount;
  }

  // A click anywhere on a row opens the subscription, unless text was being
  // selected to copy.
  openFromRow(data: any) {
    if (window.getSelection()?.toString()) return;
    this.router.navigateByUrl(this.getDetailLink(data.id));
  }
}
